import { CollectionsLobbyEventTypes } from '../../../../page/collections_lobby/utils/events/types';
import { CollectionPageEventTypes } from '../../../../page/collection_page/utils/events/types';

export const EventTypes = {
    collectionsLobby: CollectionsLobbyEventTypes,
    collectionPage: CollectionPageEventTypes,
    shared: {
        modals: {
            editCollection: {
                show: 'shared.modals.edit_collection.show',
                cancel: 'shared.modals.edit_collection.cancel',
                submit: 'shared.modals.edit_collection.submit',
                fail: 'shared.modals.edit_collection.fail',
            },
            socialShare: {
                show: 'shared.modals.social_share.show',
            },
            shareWithTeam: {
                show: 'shared.modals.share_with_team.show',
                cancel: 'shared.modals.share_with_team.cancel',
                submit: 'shared.modals.share_with_team.submit',
                fail: 'shared.modals.share_with_team.fail',
            },
            deleteConfirmation: {
                show: 'shared.modals.delete_confirmation.show',
                cancel: 'shared.modals.delete_confirmation.cancel',
                submit: 'shared.modals.delete_confirmation.submit',
                fail: 'shared.modals.delete_confirmation.fail',
            },
        },
        collection: {
            create: {
                success: 'shared.collection.create.success',
            },
            update: {
                success: 'shared.collection.update.success',
            },
            shareWithTeam: {
                success: 'shared.collection.share_with_team.success',
            },
            delete: {
                success: 'shared.collection.delete.success',
            },
        },
    },
};
